// extracted by mini-css-extract-plugin
module.exports = {"chatDialogContent":"ChatDialogContent_chatDialogContent__x4Ktr","chatHistoryMessage":"ChatDialogContent_chatHistoryMessage__Kp8kg"};